import React, { useState, useEffect } from 'react';
import './scrollToTop.css';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="scroll-to-top-container">
      <button
        type="button"
        onClick={scrollToTop}
        className={`scroll-button ${isVisible ? 'visible' : ''}`}
        aria-label="Wróć na górę"
      >
        ↑
      </button>
    </div>
  );
}